export var AnimElements;
(function (AnimElements) {
    AnimElements["flame"] = "flame";
    AnimElements["heat_request"] = "heat_request";
    AnimElements["sensor_alarm"] = "sensor_alarm";
    AnimElements["bell_notification"] = "bell_notification";
    AnimElements["car_smoke"] = "car_smoke";
    AnimElements["car_autorun"] = "car_autorun";
    AnimElements["car_lock"] = "car_lock";
    AnimElements["car_siren"] = "car_siren";
    AnimElements["circuit_alarm"] = "circuit_alarm";
    AnimElements["avatar"] = "avatar";
})(AnimElements || (AnimElements = {}));
